import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/price-compare/components/PriceCompareInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/Header.tsx");
